import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react'
import { Col, Image, Row } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Form } from 'react-router-dom';
import { faHome, faLink, faBars, faLessThan, faPhone, faMailBulk, faEnvelope } from '@fortawesome/free-solid-svg-icons';
interface ModalProps {
  showModal: boolean;
  handleModal: () => void;
}
const ContactModal: React.FC<ModalProps> = ({ showModal, handleModal }) => {

  return (
    <Modal show={showModal} onHide={handleModal}
      aria-labelledby="contained-modal-title-vcenter"
      centered>
      <Modal.Header closeButton className='border-0'>
        <div>
          <Row>
            <Col md={12}><h4>Contact Sales</h4></Col>
            <Col md={12}>
              <Row>
                <Col md={4}></Col>
                <Col md={4}>
                  <FontAwesomeIcon icon={faPhone} />
                  <small className='fs-6 text'> 617-366-2838</small></Col>
                <Col md={4} >
                  <FontAwesomeIcon icon={faEnvelope} />
                  <small className='fs-6 text'> info@graydi.us</small>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </Modal.Header>
      <Modal.Body>

        <form>
          <Row>
            <Col>
              <div className="form-group">
                <label htmlFor="exampleInputEmail1">First Name</label>
                <input type="email" className="form-control rounded-0" id="exampleInputEmail1" aria-describedby="emailHelp" />
              </div>
            </Col>
            <Col>
              <div className="form-group">
                <label htmlFor="exampleInputEmail1">Last Name</label>
                <input type="email" className="form-control rounded-0" id="exampleInputEmail1" aria-describedby="emailHelp" />
              </div>
            </Col>
          </Row>
          <Row className='mt-4'>
            <Col>
              <div className="form-group">
                <label htmlFor="exampleInputPassword1">Email</label>
                <input type="email" className="form-control rounded-0" id="exampleInputPassword1" placeholder="Password" />
              </div>
            </Col>
          </Row>
          <Row className='mt-4'>
            <Col>
              <div className="form-group">
                <label htmlFor="exampleInputEmail1">Job Title</label>
                <input type="text" className="form-control rounded-0" id="exampleInputEmail1" aria-describedby="emailHelp" />
              </div>
            </Col>
            <Col>
              <div className="form-group">
                <label htmlFor="exampleInputEmail1">Phone Number</label>
                <input type="text" className="form-control rounded-0" id="exampleInputEmail1" aria-describedby="emailHelp" />
              </div>
            </Col>
          </Row>
          <Row className='mt-4'>
            <Col>
              <div className="form-group">
                <label htmlFor="exampleInputEmail1">State/Region</label>
                <input type="text" className="form-control rounded-0" id="exampleInputEmail1" aria-describedby="emailHelp" />
              </div>
            </Col>
            <Col>
              <div className="form-group">
                <label htmlFor="exampleInputEmail1">College or University Name</label>
                <input type="text" className="form-control rounded-0" id="exampleInputEmail1" aria-describedby="emailHelp" />
              </div>
            </Col>
          </Row>

          <Row className='mt-4'>
            <Col md={4}></Col>
            <Col md={4}>
              <button type="submit" className="btn btn-light border border-dark  w-100">Cancel</button>
            </Col>
            <Col md={4}>
              <button type="submit" className="btn btn-primary bg-3 border-0 text-dark w-100">Send Form</button>
            </Col>
          </Row>
        </form>

        <Row>

        </Row>
      </Modal.Body>

    </Modal>
  )
}

export default ContactModal